<template>
  <div
    v-if="pagination.data && pagination.last_page > 1"
    class="pager">
    <vue-paginate
      :container-class="'pagination'"
      :items="pagination.data"
      :page-count="pagination.last_page"
      :value="pagination.current_page"
      :prev-text="'<'"
      :next-text="'>'"
      :active-class="'active'"
      :prev-class="'prev'"
      :next-class="'next'"
      :break-view-class="'leader'"
      :click-handler="onPaginationClicked"
      :page-class="'page-item'"></vue-paginate>
  </div>
</template>

<script>
import vuePaginate from 'vuejs-paginate'

export default {
  name: 'Pagination',
  components: {
    vuePaginate,
  },
  props: {
    pagination: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onPaginationClicked(page) {
      this.$emit('on-pagination-clicked', page)
    },
  },
}
</script>

<style>
.pagination A {
  padding-top: 4px;
}
.pagination .active A {
  background: #e2dcd7;
  color: #fff;
}
</style>
